export default __webpack_public_path__ + "static/media/36I-102808_-17589_0.466f1460.jpg";